module.exports = __webpack_public_path__ + "media/images/badge-fullcolor-alpha__-601b3e7ac1209250f4faa3e2cbd4eb34.png";